import { Action } from '@ngrx/store';

export const ADD_PENSION_PROVIDERS_LIST = '[PP_LIST] Add';
export const REMOVE_PENSION_PROVIDERS_LIST = '[PP_LIST] Remove';

// Fetch PensionProvidersList
export class AddPensionProvidersList implements Action {
    readonly type = ADD_PENSION_PROVIDERS_LIST;

    constructor(public payload) { }
}
// Remove PensionProvidersList
export class RemovePensionProvidersList implements Action {
    readonly type = REMOVE_PENSION_PROVIDERS_LIST;

    constructor(public payload: number) { }
}

export type Actions = AddPensionProvidersList | RemovePensionProvidersList;
